import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetDeliveryHistory = createAsyncThunk(  
    'DeliveryHistory/History',
    async ({status,offsetValue}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`Sales/DeliveryHistoryContorller/GetDeliveryHistory?DOCSTATUS=${status}&offsetValue=${offsetValue}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetHistoryItem = createAsyncThunk(  
    'DeliveryHistory/HistoryItem',
    async ({DocEntry,value}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`Sales/DeliveryHistoryContorller/GetHistoryItem?DOCENTRY=${DocEntry}&TabName=${value}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
                